import portfolioImg1 from '../../assets/111.jpg';
import portfolioImg2 from '../../assets/121.jpg';
import portfolioImg3 from '../../assets/131.jpg';
import portfolioImg4 from '../../assets/141.jpg';
import portfolioImg5 from '../../assets/portfolio-9.jpg';
import portfolioImg6 from '../../assets/151.jpg';
import portfolioImg7 from '../../assets/Slide15.jpg';
import portfolioImg8 from '../../assets/161.jpg';
import portfolioImg9 from '../../assets/171.jpg';
import portfolioImg10 from '../../assets/181.jpg';
import portfolioImg11 from '../../assets/191.jpg';
import portfolioImg12 from '../../assets/201.jpg';
import portfolioImg18 from '../../assets/211.jpg';
import portfolioImg14 from '../../assets/221.jpg';
import portfolioImg15 from '../../assets/231.jpg';
import portfolioImg16 from '../../assets/241.jpg';
import portfolioImg17 from '../../assets/251.jpg';
import portfolioImg13 from '../../assets/261.jpg';

const portfolioItems = [
  {
    id: 1,
    img: portfolioImg1,
    width: 1080,
    height: 780,

    category: 'Maya',
    title: 'Maya',
    description: 'First website',
  },
  {
    id: 2,
    img: portfolioImg2,
    width: 1080,
    height: 620,
    category: 'Blender',
    title: 'Blender',
    description: 'first mobile app',
  },
  {
    id: 3,
    img: portfolioImg3,
    width: 1080,
    height: 720,
    category: 'Maya',
    title: 'Maya',
    description: 'Second website',
  },
  {
    id: 4,
    img: portfolioImg4,
    category: 'Blender',
    title: 'Blender',
    description: 'second mobile app',
    width: 1080,
    height: 721,
  },
  // {
  //   id: 5,
  //   img: portfolioImg5,
  //   category: "3D",
  //   title: "3D",
  //   description: "first desktop app",
  //   width: 1080,
  //   height: 620,
  // },
  {
    id: 6,
    img: portfolioImg6,
    category: 'Maya',
    title: 'Maya',
    description: 'Third website',
    width: 1080,
    height: 900,
  },
  // {
  //   id: 7,
  //   img: portfolioImg7,
  //   category: "mobile",
  //   title: "mobile3",
  //   description: "third mobile app",
  //   width: 1080,
  //   height: 608,
  // },
  {
    id: 8,
    img: portfolioImg8,
    category: 'Maya',
    title: 'Maya',
    description: 'Forth website',
    width: 1080,
    height: 720,
  },
  {
    id: 9,
    img: portfolioImg9,
    category: 'Creo',
    title: 'Creo',
    description: 'second desktop app',
    width: 1080,
    height: 620,
  },
  {
    id: 10,
    img: portfolioImg10,
    width: 1080,
    height: 780,

    category: 'Maya',
    title: 'Maya',
    description: 'First website',
  },
  {
    id: 11,
    img: portfolioImg11,
    width: 1080,
    height: 620,
    category: 'Blender',
    title: 'Blender',
    description: 'first mobile app',
  },
  {
    id: 12,
    img: portfolioImg12,
    width: 1080,
    height: 720,
    category: 'Maya',
    title: 'Maya',
    description: 'Second website',
  },
  {
    id: 13,
    img: portfolioImg13,
    category: 'Blender',
    title: 'Blender',
    description: 'second mobile app',
    width: 1080,
    height: 721,
  },
  {
    id: 14,
    img: portfolioImg14,
    category: 'Maya',
    title: 'Maya',
    description: 'first desktop app',
    width: 1080,
    height: 620,
  },
  {
    id: 15,
    img: portfolioImg15,
    category: 'Maya',
    title: 'Maya',
    description: 'Third website',
    width: 1080,
    height: 900,
  },
  {
    id: 16,
    img: portfolioImg16,
    category: 'Blender',
    title: 'Blender',
    description: 'third mobile app',
    width: 1080,
    height: 608,
  },
  {
    id: 17,
    img: portfolioImg17,
    category: 'Maya',
    title: 'Maya',
    description: 'Forth website',
    width: 1080,
    height: 720,
  },
  {
    id: 18,
    img: portfolioImg18,
    category: 'Creo',
    title: 'Creo',
    description: 'second desktop app',
    width: 1080,
    height: 620,
  },
];
const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];
export const portfolioPhotos = portfolioItems.map((item) => {
  const width = breakpoints[0];
  const height = (item.height / item.width) * width;

  return {
    src: item.img,
    width,
    height,
    title: item.title,
    category: item.category,
    description: item.description,
    images: breakpoints.map((breakpoint) => {
      const height = Math.round((item.height / item.width) * breakpoint);
      return {
        src: item.img,
        width: breakpoint,
        height,
      };
    }),
  };
});
export const categories = [
  'all',
  ...new Set(portfolioItems.map(({ category }) => category)),
];
